/* eslint-disable no-param-reassign */
import { ApiResourcesFactory } from '@/api/api-resources-factory';
import { apiRequestFactory } from '@/api/api-requests-factory';
import { useAuth } from '@/store/auth.store';
import { useEnvStore } from '@/store/env.store';
import { storeToRefs } from 'pinia';
import { authErrorCodes, authForbiddenCode } from '@/models/auth/auth.model';
import { DASHBOARD_MODES } from '@/models/common/env.model';
import { ElNotification } from 'element-plus';

export const apiResourcesFactory = new ApiResourcesFactory();
export const http = apiRequestFactory.getRequestPerformer();

http.setInterceptor({
  request: {
    onFulfilled(config) {
      const { token } = storeToRefs(useAuth());

      if (!config.headers) {
        config.headers = {};
      }

      if (token.value) {
        config.headers['X-Auth-Token'] = token.value;
      }

      return config;
    },
  },
  response: {
    onFulfilled(response) {
      if (response.data.textCode) {
        ElNotification({
          title: 'Error',
          message: response.data.message,
          type: 'error',
        });
        throw new Error(response.data.message);
      }

      return response;
    },
    onRejected(error) {
      const { setToken } = useAuth();
      const { APP_MODE } = useEnvStore();

      if (authErrorCodes.includes(error.response.status)) {
        setToken('');

        const isReload = APP_MODE === DASHBOARD_MODES.BACKOFFICE;
        if (isReload) {
          window.location.reload();
        }
      }

      if (error.response.status === authForbiddenCode) {
        ElNotification({
          title: 'Error',
          message: error.response.data.message,
          type: 'error',
        });
      }

      throw error;
    },
  },
});

export const api = apiResourcesFactory.getInstance(http);
